import React from 'react';

export interface PairUpLogoProps {
  className?: string;
  size?: number | string;
  showText?: boolean;
  textColor?: 'dark' | 'light';
  tagline?: boolean;
  alt?: string;
}

/**
 * PairUpToday Official Golden Ring Logo Component
 * 
 * Rules & Specifications:
 * 1. Asset Source: Strictly /assets/image_AIIEuv.png
 * 2. Strict Boundary Masking (Clip Path):
 *    className="rounded-full border border-amber-400 object-cover overflow-hidden shadow-lg"
 *    Completely crops out outer black corners, revealing the inner golden circular ring.
 * 3. Layout Context:
 *    - Navbar: w-10 h-10 to w-12 h-12
 *    - Auth / Welcome Screens: w-32 h-32 to w-40 h-40
 *    - Sidebar / Footer: aspect-square responsive preservation
 */
export const PairUpLogo: React.FC<PairUpLogoProps> = ({
  className = 'w-10 h-10',
  size,
  showText = false,
  textColor = 'dark',
  tagline = false,
  alt = 'PairUpToday Golden Ring Logo',
}) => {
  const isLight = textColor === 'light';

  const imageElement = (
    <img
      src="/assets/image_AIIEuv.png"
      alt={alt}
      className={`rounded-full border border-amber-400 object-cover overflow-hidden shadow-lg aspect-square scale-[1.03] shrink-0 ${
        size ? '' : className
      }`}
      style={size ? { width: size, height: size } : undefined}
      loading="eager"
    />
  );

  if (!showText) {
    return imageElement;
  }

  return (
    <div className="flex items-center gap-2.5">
      {imageElement}
      <div className="flex flex-col">
        <div className="flex items-center tracking-tight leading-none">
          <span className={`font-extrabold text-xl font-sans ${isLight ? 'text-white' : 'text-slate-900'}`}>
            PairUp
          </span>
          <span className="font-extrabold text-xl text-pink-600 font-sans ml-0.5">
            Today
          </span>
        </div>
        {tagline && (
          <span className={`text-[10px] font-semibold mt-0.5 tracking-wide ${isLight ? 'text-slate-400' : 'text-slate-500'}`}>
            Find Your Perfect Companion
          </span>
        )}
      </div>
    </div>
  );
};
